import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import NavigationLink from "../../components/NavigationLink/NavigationLink";
import { EditActions, editActions } from "../../actions/editActions";
import { PdApiActions, pdApiActions } from "../../actions/pdApiActions";
import { ColumnActions, columnActions } from "../../actions/columnActions";
import {
  editedObjectIdSelector,
  isEditActiveSelector,
  editedObjectIdentifierSelector,
  domainSelector
} from "../../reducers/editReducer";
import EscalatorFaultsTable from "./EscalatorFaults/EscalatorFaultsTable";
import {
  setFaultExtraProperties,
  createEmptyFault,
  createEmptyEscalatorRTD,
  createEmptyEscalatorRTDGroup,
  setEscalatorRTDExtraProperties,
  createEmptyParameter,
  setParameterExtraProperties,
  createEmptyDataActCode,
  createEmptyEscalatorEventLog,
  setEscalatorEventLogExtraProperties,
} from "../../utils/pdApiUtils";
import { ActionMenu } from "../common/ActionMenu/ActionMenu";
import ContentLayout from "../../components/ContentLayout/ContentLayout";
import { mainActions } from "../../actions/mainActions";
import { Filter } from "../../components/Table/Migration/LegacyTypes";
import EscalatorParametersTable from "./EscalatorParameters/EscalatorParametersTable";
import EscalatorEventEnumerations from "../Escalator/EscalatorEventEnumerations/EscalatorEventEnumerations";
import EscalatorBindings from "../Escalator/EscalatorBindings/EscalatorBindings";
import _ from "lodash";
import EscalatorRTDsTable from "./RTDs/EscalatorRTDsTable";
import EscalatorRTDGroupsTable from "./RTDGroups/EscalatorRTDGroupsTable";
// eslint-disable-next-line
import EscalatorDevPackage from "./EscalatorDevelopmentPackage/EscalatorDevPackage";
import EscalatorDataAct from "./DataAct/EscalatorDataAct";
import EscalatorEventLogsTable from "./EventLogs/EscalatorEventLogsTable";

type StateProps = {
  pdApi: State.PdApi;
  fetchingStatus: string | undefined;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
  domainName: string;
  toggleChildView: State.ToggleChildView;
  filterOptions: State.FilterOptions;
  isLoadingEscalatorParameters: boolean;
  isLoadingEscalatorFaults: boolean;
  isLoadingEscalatorRTDs: boolean;
  isLoadingEscalatorRTDGroups: boolean;
  isLoadingEscalatorEventLogs: boolean;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
  columnActions: typeof columnActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  subMenuRoute: State.EscalatorSubmenu;
  userFiltering?: Filter[];
};

// Props of the component
export type EscalatorProps = StateProps & DispatchProps & OwnProps;

type EscalatorState = {
  isModalOpen: boolean;
  tableColumnFilters: {
    [key in State.EscalatorSubmenu]: Filter[];
  };
  parameterFetch: boolean;
  faultFetch: boolean;
  rtdFetch: boolean;
  rtdGroupFetch: boolean;
  escalatorDataActFetch: boolean;
  eventLogFetch: boolean;
};

export class Escalator extends React.Component<EscalatorProps, EscalatorState> {
  state = {
    isModalOpen: false,
    tableColumnFilters: {
      "Escalator Faults": [],
      "Escalator Parameters": [],
      "Escalator Bindings": [],
      "Event Enumerations": [],
      "Escalator RTDs": [],
      "Escalator RTD Groups": [],
      "Development Package": [],
      "Data Acts": [],
      "Event Logs": []
    },
    parameterFetch: false,
    faultFetch: false,
    rtdFetch: false,
    rtdGroupFetch: false,
    escalatorDataActFetch: false,
    eventLogFetch: false
  };
  private groupName: Api.GroupName = "Escalator";

  componentDidMount(): void {
    const escalatorVersions = this.props.pdApi.EscalatorVersions;
    if (!escalatorVersions || _.isEmpty(escalatorVersions)) {
      // Handle the case where escalatorVersions is falsy or empty
      this.props.pdApiActions.fetchEscalatorVersions("Escalator Versions");
    }
    if (
      !this.state.parameterFetch &&
      window.location.href.includes("escalator/parameters") &&
      this.props.pdApi.escalatorParameters.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorParameters();
      this.setState({ parameterFetch: true });
    } else if (
      !this.state.faultFetch &&
      window.location.href.includes("escalator/faults") &&
      this.props.pdApi.escalatorFaults.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorFaults();
      this.setState({ faultFetch: true });
    } else if (
      !this.state.rtdFetch &&
      window.location.href.includes("escalator/RTDs") &&
      this.props.pdApi.escalatorRTDs.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorRTDs();
      this.props.pdApiActions.fetchEscalatorRTDGroups();
      this.setState({ rtdFetch: true });
    } else if (
      !this.state.rtdGroupFetch &&
      window.location.href.includes("escalator/RTD-Groups") &&
      this.props.pdApi.escalatorRTDGroups.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorRTDGroups();
      this.props.pdApiActions.fetchEscalatorRTDs();
      this.setState({ rtdGroupFetch: true });
    } else if (
      !this.state.escalatorDataActFetch &&
      window.location.href.includes("escalator/data-acts") &&
      this.props.pdApi.escalatorDataActCodes === undefined
    ) {
      this.props.pdApiActions.fetchEscalatorDataActCodes();
      this.setState({ escalatorDataActFetch: true });
    } else if (
      !this.state.eventLogFetch &&
      window.location.href.includes("escalator/event-logs") &&
      this.props.pdApi.escalatorEventLogs.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorEventLogs();
      this.setState({ eventLogFetch: true });
    }
  }

  /**
   * To add new sub page to this parent, add it here
   */
  subPages: Internal.SubPages = {
    "Escalator Parameters": {
      itemName: "parameter",
      PdApiField: "escalatorParameters",
      dataView: EscalatorParametersTable,
      createEmpty: createEmptyParameter,
      setExtraProperties: setParameterExtraProperties
    },
    "Escalator Faults": {
      itemName: "fault",
      PdApiField: "escalatorFaults",
      dataView: EscalatorFaultsTable,
      createEmpty: createEmptyFault,
      setExtraProperties: setFaultExtraProperties
    },
    "Escalator Bindings": {
      itemName: "binding",
      createEmpty: () => {
      /*  */
      },
      PdApiField: "domains",
      dataView: EscalatorBindings,
      setExtraProperties: null
    },
    "Event Enumerations": {
      itemName: "event enumeration",
      PdApiField: null,
      createEmpty: () => {
        /*  */
      },
      setExtraProperties: null,
      dataView: EscalatorEventEnumerations
    },
    "Event Logs": {
      itemName: "event log",
      PdApiField: "escalatorEventLogs",
      dataView: EscalatorEventLogsTable,
      createEmpty: createEmptyEscalatorEventLog,
      setExtraProperties: setEscalatorEventLogExtraProperties
    },
    "Escalator RTDs": {
      itemName: "RTD",
      PdApiField: "escalatorRTDs",
      dataView: EscalatorRTDsTable,
      createEmpty: createEmptyEscalatorRTD,
      setExtraProperties: setEscalatorRTDExtraProperties
    },
    "Escalator RTD Groups": {
      itemName: "RTD Group",
      PdApiField: "escalatorRTDGroups",
      dataView: EscalatorRTDGroupsTable,
      createEmpty: createEmptyEscalatorRTDGroup,
      setExtraProperties: null
    },
    "Data Acts": {
      itemName: "data act",
      PdApiField: "escalatorDataActCodes",
      dataView: EscalatorDataAct,
      createEmpty: createEmptyDataActCode,
      setExtraProperties: null
    },
    "Development Package": {
      itemName: "development package",
      PdApiField: "domains",
      createEmpty: () => {
        // No action needed for development package
      },
      setExtraProperties: null,
      dataView: EscalatorDevPackage
    }
  };
  render(): JSX.Element {
    const { subMenuRoute } = this.props;
    const submenuLinks = Object.keys(this.subPages).map((subPageName: Api.AnyItem) =>
      this.buildLink(subPageName)
    );
    const actionMenu = this.getActionMenu(subMenuRoute);
    const dataView = this.getDataView(subMenuRoute);
    const modal = this.subPages[subMenuRoute].PdApiField ? this.buildModal() : null;
    return (
      <>
        <ContentLayout submenu={submenuLinks} actionMenu={actionMenu} dataView={dataView} />
        {modal}
      </>
    );
  }

  private handleLinkClick = (subPageName: Api.AnyItem) => {
    this.props.editActions.cancelEditing;

    if (
      subPageName === "Escalator Faults" &&
      !this.state.faultFetch &&
      this.props.pdApi.escalatorFaults.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorFaults();
      this.setState({ faultFetch: true });
    } else if (
      subPageName === "Escalator Parameters" &&
      !this.state.parameterFetch &&
      this.props.pdApi.escalatorParameters.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorParameters();
      this.setState({ parameterFetch: true });
    } else if (
      subPageName === "Escalator RTDs" &&
      !this.state.rtdFetch &&
      this.props.pdApi.escalatorRTDs.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorRTDs();
      this.props.pdApiActions.fetchEscalatorRTDGroups();
      this.setState({ rtdFetch: true });
    } else if (
      subPageName === "Escalator RTD Groups" &&
      !this.state.rtdGroupFetch &&
      this.props.pdApi.escalatorRTDGroups.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorRTDGroups();
      this.props.pdApiActions.fetchEscalatorRTDs();
      this.setState({ rtdGroupFetch: true });
    } else if (
      subPageName === "Data Acts" &&
      !this.state.escalatorDataActFetch &&
      this.props.pdApi.escalatorDataActCodes === undefined
    ) {
      this.props.pdApiActions.fetchEscalatorDataActCodes();
      this.setState({ escalatorDataActFetch: true });
    } else if (
      subPageName === "Event Logs" &&
      !this.state.eventLogFetch &&
      this.props.pdApi.escalatorEventLogs.length === 0
    ) {
      this.props.pdApiActions.fetchEscalatorEventLogs();
      this.setState({ eventLogFetch: true });
    }
  };

  private setColumnFilters = (subMenuRoute: State.EscalatorSubmenu, newFilters: Filter[]): void => {
    const newFilterSet = { ...this.state.tableColumnFilters, [subMenuRoute]: newFilters };
    this.setState(prevState => ({
      ...prevState,
      tableColumnFilters: newFilterSet
    }));
  };

  private getDataView = (subMenuRoute: State.EscalatorSubmenu): JSX.Element => {
    if (subMenuRoute in this.subPages) {
      const passProps = {
        ...this.props,
        toggleModal: this.toggleModal,
        setColumnFilters: this.setColumnFilters
      };
      return React.createElement(this.subPages[subMenuRoute].dataView, passProps);
    }
    return <>Error</>;
  };

  private getActionMenu = (subMenuRoute: State.EscalatorSubmenu): JSX.Element | null => {
    if (subMenuRoute === "Event Enumerations" 
      || subMenuRoute === "Escalator Bindings" 
      || subMenuRoute === "Development Package" 
      || this.subPages[subMenuRoute].PdApiField === null) {
      return null;
    }

    return (
      <ActionMenu
        {...this.props}
        itemName={this.subPages[subMenuRoute].itemName}
        groupName={this.groupName}
        selectedColumnsName={subMenuRoute}
        dataFieldName={this.subPages[subMenuRoute].PdApiField}
        setExtraProperties={this.subPages[subMenuRoute].setExtraProperties}
        createEmpty={this.subPages[subMenuRoute].createEmpty}
        columnFilters={this.state.tableColumnFilters[subMenuRoute]}
      />
    );
  };

  private buildLink = (subPageName: State.EscalatorSubmenu): JSX.Element => {
    // To dynamically build urls we use the itenName and make it plural, so -s || -y => -ies
    let parsedLink = this.subPages[subPageName].itemName.replace(" ", "-");
    parsedLink = parsedLink.slice(-1) === "y" ? parsedLink.slice(0, -1) + "ies" : parsedLink + "s";
    return (
      <NavigationLink
        key={subPageName}
        handleOnClick={() => this.handleLinkClick(subPageName)}
        name={subPageName}
        to={"/escalator/" + parsedLink + "/"}
      />
    );
  };

  private buildModal = () => {
    const domainName = this.props.domainName ? " Domain: " + this.props.domainName : "";
    const content = (
      <span>
        Are you sure you want to delete this {this.subPages[this.props.subMenuRoute].itemName}?
        <br />
        {this.props.objectIdentifier}
        <br /> {domainName}
      </span>
    );

    return (
      <ConfirmationModal
        isOpen={this.state.isModalOpen}
        size="mini"
        header="Confirm delete"
        content={content}
        confirmText="Confirm"
        cancelText="Cancel"
        onConfirm={() => {
          if (this.subPages[this.props.subMenuRoute].itemName === "data act") {
            this.props.editActions.delete("escalatorDataActs");
          } else {
            this.props.editActions.delete(
              this.subPages[this.props.subMenuRoute].PdApiField as Api.OptionsGrud
            );
          }
        }}
        onCancel={this.toggleModal}
      />
    );
  };

  /*
   * Toggles the modal based on previous state.
   */
  private toggleModal = (): void => {
    this.setState(prevState => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen
    }));
  };
}

const mapStateToProps = (state: State.Root, ownProps: OwnProps) => ({
  fetchingStatus: state.main.fetchingStatus,
  columns: state.columns,
  pdApi: state.pdApi,
  mainState: state.main,
  isLoadingEscalatorParameters: state.loadingStatus.isLoadingEscalatorParameters,
  isLoadingEscalatorFaults: state.loadingStatus.isLoadingEscalatorFaults,
  isLoadingEscalatorRTDs: state.loadingStatus.isLoadingEscalatorRTDs,
  isLoadingEscalatorRTDGroups: state.loadingStatus.isLoadingEscalatorRTDGroups,
  isLoadingEscalatorEventLogs: state.loadingStatus.isLoadingEscalatorEventLogs,
  isEditActive: isEditActiveSelector(state.editView),
  editedObjectId: editedObjectIdSelector(state.editView),
  objectIdentifier: editedObjectIdentifierSelector(state.editView, ownProps.subMenuRoute),
  domainName: domainSelector(state.editView),
  toggleChildView: state.toggleChildView,
  filterOptions: state.filterOptions
});

const mapDispatchToProps = (dispatch: Dispatch<PdApiActions | ColumnActions | EditActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch),
  columnActions: bindActionCreators({ ...columnActions }, dispatch),
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Escalator);
